import React, { FC, PropsWithChildren } from "react";
import { Select as MuiSelect, type SelectProps } from "@mui/material";
import FeatherIcon from "feather-icons-react";

const Select: FC<PropsWithChildren<SelectProps>> = ({ children, ...props }) => {
  const Icon: FC<{ className?: string }> = ({ className }) => (
    <span className={className} style={{ pointerEvents: "none" }}>
      <FeatherIcon icon="chevron-down" size={24} />
    </span>
  );

  return (
    <MuiSelect IconComponent={Icon} {...props}>
      {children}
    </MuiSelect>
  );
};

export default Select;
